module.exports = __webpack_public_path__ + "img/step1.a40386ce.png";